import { connect_to_vm_lead_sources, free_food_tasting_lead_sources, have_us_call_you_lead_sources, leadSourceText } from "../constants/enquiryConst"

export const getTagNameFromSource=(source)=>{
    if(have_us_call_you_lead_sources.includes(source)) return leadSourceText['have_us_call_you']
    else if (connect_to_vm_lead_sources.includes(source)) return leadSourceText['connect_to_vm']
    else if(free_food_tasting_lead_sources.includes(source)) return leadSourceText['free_food_tasting']
    else return null
}